import React, { useState } from 'react';
import axios from 'axios';
import { Link } from "react-router-dom"; // <-- use client-side routing

const MODULE_NAME = "_43_login";

// Simple lock icon SVG component
const LockIcon = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        style={{ marginRight: 8, verticalAlign: "middle" }}
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect x="5" y="9" width="10" height="7" rx="2" fill="#fff" />
        <path d="M7 9V7a3 3 0 1 1 6 0v2" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const _43_login = (props) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const screen = props.screen;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setLoading(true);
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/login`,
                { email, password },
                { withCredentials: true }
            );
            if (res.data.success) {
                setSuccess(res.data.message || 'Login successful!');
                setError('');
                // ✅ FIXED: Store account_type in sessionStorage before calling onLoginSuccess
                if (res.data.account_type) {
                    sessionStorage.setItem("account_type", res.data.account_type);
                }
                if (res.data.user_type) {
                    sessionStorage.setItem("user_type", res.data.user_type);
                }
                if (res.data.TonVersion) {
                    sessionStorage.setItem("TonVersion", res.data.TonVersion);
                }
                // ✅ FIXED: Pass account_type instead of user_type
                if (typeof props.onLoginSuccess === "function") {
                    props.onLoginSuccess(res.data.account_type);
                }
            } else {
                setError(res.data.message || 'Login failed.');
                setSuccess('');
            }
        } catch (err) {
            setError(
                err.response?.data?.message ||
                'Login failed. Please try again.'
            );
            setSuccess('');
        }
        setLoading(false);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    return (
        <div className="_43_login-container" style={{ maxWidth: 400, margin: "0 auto", padding: 24 }} data-analytics={MODULE_NAME}>
            <h2 style={{ textAlign: "center" }}>Login</h2>
            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 16 }}>
                    <label htmlFor="email" style={{ display: "block", fontWeight: "bold" }}>Email:</label>
                    <input
                        id="email"
                        type="email"
                        value={email}
                        onChange={handleEmailChange}
                        autoComplete="username"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc", color: "#e4e6e4", background: "#1E1E1E" }}
                        required
                    />
                </div>
                <div style={{ marginBottom: 16 }}>
                    <label htmlFor="password" style={{ display: "block", fontWeight: "bold" }}>Password:</label>
                    <input
                        id="password"
                        type="password"
                        value={password}
                        onChange={handlePasswordChange}
                        autoComplete="current-password"
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc", color: "#e4e6e4", background: "#1E1E1E" }}
                        required
                    />
                </div>
                <button
                    type="submit"
                    disabled={loading}
                    style={{
                        width: "100%",
                        padding: 10,
                        background: "#2ecc71",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        cursor: loading ? "not-allowed" : "pointer"
                    }}
                >
                    <LockIcon />
                    {loading ? "Logging in..." : "Login"}
                </button>
                {error && <p style={{ color: "red", marginTop: 12, textAlign: "center" }}>{error}</p>}
                {success && <p style={{ color: "green", marginTop: 12, textAlign: "center" }}>{success}</p>}
            </form>
            <div style={{ marginTop: 20, textAlign: "center", fontSize: 14 }}>
                <p>
                    Don't have an account? <Link to="/auth?screen=register" style={{ color: "#2ecc71", textDecoration: "none", fontWeight: "bold" }}>Register</Link>
                </p>
                <p>
                    <Link to="/auth?screen=password-reset" style={{ color: "#457b9d", textDecoration: "none" }}>Forgot Password?</Link>
                </p>
            </div>
        </div>
    );
};

export default _43_login;